import React, { useState, useEffect } from 'react';

const allItems = [
  { image: 'https://upload.wikimedia.org/wikipedia/commons/1/15/Red_Apple.jpg', color: 'Red', type: 'Fruit', size: 'Small', material: 'Organic' },
  { image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSxI_xxg8DuZf92kEDmCHj3Uqv9GIn5WocapA&s', color: 'Brown', type: 'Toy', size: 'Medium', material: 'Fabric' },
  { image: 'https://upload.wikimedia.org/wikipedia/commons/3/37/African_Bush_Elephant.jpg', color: 'Gray', type: 'Animal', size: 'Large', material: 'Flesh' },
  { image: 'https://upload.wikimedia.org/wikipedia/commons/8/8a/Banana-Single.jpg', color: 'Yellow', type: 'Fruit', size: 'Medium', material: 'Organic' },
  { image: 'https://upload.wikimedia.org/wikipedia/commons/2/29/PerfectStrawberry.jpg', color: 'Red', type: 'Fruit', size: 'Small', material: 'Organic' },
  { image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR67L-L6qZpIsBfylK-Zkzl4tjxAnEXG9TDEQ&s', color: 'Red', type: 'Drink', size: 'Medium', material: 'Liquid' },
  { image: 'https://www.balisafarimarinepark.com/wp-content/uploads/2021/09/IMG_9210-1024x683.jpg', color: 'Orange', type: 'Animal', size: 'Large', material: 'Flesh' },
  { image: 'https://www.foodrepublic.com/img/gallery/15-types-of-grapes-to-know-eat-and-drink/thomcord-1743188190.jpg', color: 'Purple', type: 'Fruit', size: 'Small', material: 'Organic' },
  { image: 'https://images.squarespace-cdn.com/content/v1/54822a56e4b0b30bd821480c/45ed8ecf-0bb2-4e34-8fcf-624db47c43c8/Golden+Retrievers+dans+pet+care.jpeg', color: 'Brown', type: 'Animal', size: 'Large', material: 'Flesh' },
  { image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlGhyCWSAbpcxSyEmyu8j4s-mjRoaN8n-2xA&s', color: 'Blue', type: 'Toy', size: 'Large', material: 'Metal' },
  { image: 'https://upload.wikimedia.org/wikipedia/commons/c/cb/Pineapple_and_cross_section.jpg', color: 'Yellow', type: 'Fruit', size: 'Large', material: 'Organic' },
  { image: 'https://juicehouse.in/wp-content/uploads/2025/03/7-1.jpg', color: 'Purple', type: 'Drink', size: 'Large', material: 'Liquid' },
  { image: 'https://i.pinimg.com/736x/3b/d7/65/3bd765446f4fbc4e5b0b6cab8732f3c5.jpg', color: 'Blue', type: 'Drink', size: 'Small', material: 'Ice' },
  { image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSZMG4A7NiyhRqIY3jncXZWQVs2d8qvSeyNDA&s', color: 'Orange', type: 'Drink', size: 'Small', material: 'Liquid' }
];

const challenges = [
  { text: '🔴 Find all Red Fruits!', filter: i => i.color === 'Red' && i.type === 'Fruit' },
  { text: '🐘 Find all Large Animals!', filter: i => i.size === 'Large' && i.type === 'Animal' },
  { text: '🧃 Find all Small Purple Fruits or Drinks!', filter: i => i.size === 'Small' && (i.color === 'Purple' || i.type === 'Drink') },
  { text: '🧸 Find all Medium Toys or Red Drinks!', filter: i => (i.size === 'Medium' && i.type === 'Toy') || (i.color === 'Red' && i.type === 'Drink') },
  { text: '💧 Find all Small Blue Ice or Drinks!', filter: i => i.size === 'Small' && (i.color === 'Blue' || i.material === 'Ice') },
  { text: '🟡 Find all Yellow Fruits or Medium-sized Toys!', filter: i => (i.color === 'Yellow' && i.type === 'Fruit') || (i.size === 'Medium' && i.type === 'Toy') },
  { text: '🍹 Find all Drinks that are NOT Red!', filter: i => i.type === 'Drink' && i.color !== 'Red' },
  { text: '🧵 Find all items made of Fabric or Metal!', filter: i => i.material === 'Fabric' || i.material === 'Metal' },
  { text: '🚫 Find all items that are NOT Animals and NOT Large!', filter: i => i.type !== 'Animal' && i.size !== 'Large' },
  { text: '🥗 Find all Organic items that are Small or Medium!', filter: i => i.material === 'Organic' && (i.size === 'Small' || i.size === 'Medium') }
];

const styles = {
  body: {
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    background: 'linear-gradient(to right, #e0f7fa, #fff3e0)',
    textAlign: 'center',
    padding: 30,
    minHeight: '100vh',
  },
  heading: {
    color: '#00796b',
    fontSize: '2.5em',
    margin: 0,
  },
  instruction: {
    fontSize: '1.4em',
    margin: '20px',
    color: '#d84315',
  },
  cardContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '20px',
    marginTop: 20,
  },
  card: {
    width: 160,
    height: 230,
    perspective: 1000,
    cursor: 'pointer',
  },
  cardInner: {
    position: 'relative',
    width: '100%',
    height: '100%',
    transition: 'transform 0.6s',
    transformStyle: 'preserve-3d',
  },
  cardInnerFlipped: {
    transform: 'rotateY(180deg)',
  },
  cardFace: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backfaceVisibility: 'hidden',
    border: '2px solid #444',
    borderRadius: 12,
    backgroundColor: '#fff',
    boxShadow: '2px 2px 8px rgba(0,0,0,0.2)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 10,
    userSelect: 'none',
  },
  cardFrontImg: {
    width: 80,
    height: 80,
    objectFit: 'contain',
  },
  cardBack: {
    transform: 'rotateY(180deg)',
    fontSize: '0.9em',
    color: '#333',
    position: 'absolute',
    width: '100%',
    height: '100%',
    backfaceVisibility: 'hidden',
    border: '2px solid #444',
    borderRadius: 12,
    backgroundColor: '#fff',
    boxShadow: '2px 2px 8px rgba(0,0,0,0.2)',
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  cardBackSelected: {
    backgroundColor: '#c8e6c9',
    borderColor: '#2e7d32',
  },
  cardBackDivBefore: {
    content: '"🔸 "',
  },
  button: {
    fontSize: '1em',
    padding: '10px 25px',
    margin: '20px 10px 0',
    backgroundColor: '#0288d1',
    color: 'white',
    border: 'none',
    borderRadius: 10,
    cursor: 'pointer',
    transition: '0.3s ease',
  },
  buttonHover: {
    backgroundColor: '#01579b',
  },
  result: {
    marginTop: 20,
    fontSize: '1.2em',
    color: '#33691e',
  },
};

function DataDetective() {
  const [currentChallengeIndex, setCurrentChallengeIndex] = useState(0);
  const [currentItems, setCurrentItems] = useState([]);
  const [flippedStates, setFlippedStates] = useState([]); // array of booleans to track flipped cards
  const [selectedStates, setSelectedStates] = useState([]); // array of booleans to track selected cards
  const [resultMessage, setResultMessage] = useState('');

  // Load challenge and set items + reset states
  useEffect(() => {
    const challenge = challenges[currentChallengeIndex];
    let filteredItems = allItems.filter(challenge.filter);
    filteredItems = filteredItems.sort(() => 0.5 - Math.random()).slice(0, 4);
    setCurrentItems(filteredItems);
    setFlippedStates(new Array(filteredItems.length).fill(false));
    setSelectedStates(new Array(filteredItems.length).fill(false));
    setResultMessage('');
  }, [currentChallengeIndex]);

  const toggleFlipSelect = index => {
    setFlippedStates(prev => {
      const copy = [...prev];
      copy[index] = !copy[index];
      return copy;
    });
    setSelectedStates(prev => {
      const copy = [...prev];
      copy[index] = !copy[index];
      return copy;
    });
  };

  const checkAnswers = () => {
    const challenge = challenges[currentChallengeIndex];
    let correct = 0;
    let totalCorrect = currentItems.length;

    selectedStates.forEach((selected, idx) => {
      if (selected && challenge.filter(currentItems[idx])) {
        correct++;
      }
    });

    const allCorrectSelected = correct === totalCorrect;
    const noWrongSelected = selectedStates.every((selected, idx) => {
      if (selected) return challenge.filter(currentItems[idx]);
      return true; // unselected are ok
    });

    if (allCorrectSelected && noWrongSelected && selectedStates.some(s => s === true)) {
      setResultMessage('🎉 Great job! You found them all!');
    } else {
      setResultMessage(`🧐 You found ${correct} correct item(s). Try again!`);
    }
  };

  const nextQuestion = () => {
    setCurrentChallengeIndex((prev) => (prev + 1) % challenges.length);
  };

  return (
    <div style={styles.body}>
      <h1 style={styles.heading}>🤖 Data Detective: Train the Robot!</h1>
      <div style={styles.instruction}>{challenges[currentChallengeIndex].text}</div>

      <div style={styles.cardContainer}>
        {currentItems.map((item, idx) => {
          const flipped = flippedStates[idx];
          const selected = selectedStates[idx];
          return (
            <div
              key={idx}
              style={styles.card}
              onClick={() => toggleFlipSelect(idx)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === 'Enter') toggleFlipSelect(idx); }}
            >
              <div
                style={{
                  ...styles.cardInner,
                  ...(flipped ? styles.cardInnerFlipped : {}),
                }}
              >
                <div style={styles.cardFace}>
                  <img src={item.image} alt="item" style={styles.cardFrontImg} />
                </div>
                <div
                  style={{
                    ...styles.cardBack,
                    ...(selected ? styles.cardBackSelected : {}),
                  }}
                >
                  <div><strong>Color:</strong> {item.color}</div>
                  <div><strong>Type:</strong> {item.type}</div>
                  <div><strong>Size:</strong> {item.size}</div>
                  <div><strong>Material:</strong> {item.material}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div>
        <button
          style={styles.button}
          onClick={checkAnswers}
          type="button"
        >
          Check Answers
        </button>
        <button
          style={styles.button}
          onClick={nextQuestion}
          type="button"
        >
          Next Challenge
        </button>
      </div>

      <div style={styles.result}>{resultMessage}</div>
    </div>
  );
}

export default DataDetective;
